import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Field } from '@applyboard/ui-components';
import { Button } from '@applyboard/crystal-ui';
import { PreferencesContainer } from "../../Layout/PreferencesContainer";
import { Layout } from "../../Layout";
import { FieldsOfEducationField } from "./FieldsOfEducationField";
export var Content = function Content(_ref) {
  var options = _ref.options,
    skipFieldOfEducationSubmit = _ref.skipFieldOfEducationSubmit;
  var skipButton = /*#__PURE__*/React.createElement(Button, {
    "aria-label": "",
    emphasis: "highlighted",
    intent: "secondary",
    size: "lg",
    onClick: skipFieldOfEducationSubmit,
    width: "fill",
    type: "button"
  }, "Skip");
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(PreferencesContainer, {
    skipButton: skipButton
  }, /*#__PURE__*/React.createElement(Field, {
    as: FieldsOfEducationField,
    name: "fieldsOfEducation",
    label: "What would you like to study?",
    options: options,
    required: "Please select at least one option."
  })));
};